// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"459acb8c","976":"0d25feef"}[chunkId] + ".chunk.js";
};